import {useEffect, useMemo, useRef} from "react";

import {RequestState} from "@pg-mono/request-state";

import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {IOfferListOffer} from "../../types/IOfferListOffer";
import {getOfferListingAmplitudeItemListContext} from "../helpers/get_offer_listing_amplitude_item_list_context";
import {isOfferListingRouteQuerySyncedWithLatestQuery} from "../helpers/is_offer_listing_route_query_synced_with_latest_query";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

type OfferListingRouteQuery = Record<string, string | string[] | null | boolean | undefined>;

interface IUseOfferListingAmplitudeViewItemListTrackingParams {
    offers: IOfferListOffer[];
    listingTitle: string;
    routeQuery: OfferListingRouteQuery;
    latestQuery: IOfferListLatestQuery;
    requestState: RequestState;
    isInitialOfferListFetchDone: boolean;
    isPromotionsTab: boolean;
    showPromotionTabs: boolean;
}

const getAmplitudeViewItemListContextKey = (itemListName: string | string[], offerIds: string[]) => `${JSON.stringify(itemListName)}|${offerIds.join(",")}`;

// DS-A-32
export const useOfferListingAmplitudeViewItemListTracking = (params: IUseOfferListingAmplitudeViewItemListTrackingParams) => {
    const {offers, listingTitle, routeQuery, latestQuery, requestState, isInitialOfferListFetchDone, isPromotionsTab, showPromotionTabs} = params;

    const prevTrackedContextKeyRef = useRef<string | null>(null);

    const amplitudeItemListContext = useMemo(
        () =>
            getOfferListingAmplitudeItemListContext({
                listingTitle,
                isPromotionsTab,
                hasPromotionTabs: showPromotionTabs
            }),
        [listingTitle, isPromotionsTab, showPromotionTabs]
    );

    const offerIds = useMemo(() => offers.map(({id}) => id.toString()), [offers]);
    const isListingQuerySyncedWithRoute = isOfferListingRouteQuerySyncedWithLatestQuery(routeQuery, latestQuery);

    useEffect(() => {
        if (!isInitialOfferListFetchDone) {
            return;
        }

        if (requestState === RequestState.Waiting) {
            prevTrackedContextKeyRef.current = null;
            return;
        }

        if (requestState !== RequestState.Success || !isListingQuerySyncedWithRoute) {
            return;
        }

        const contextKey = getAmplitudeViewItemListContextKey(amplitudeItemListContext.itemListName, offerIds);

        if (prevTrackedContextKeyRef.current === contextKey) {
            return;
        }

        prevTrackedContextKeyRef.current = contextKey;

        trackAmplitudeOfferViewItemList({
            offers,
            itemListName: amplitudeItemListContext.itemListName
        });
    }, [isInitialOfferListFetchDone, requestState, isListingQuerySyncedWithRoute, offerIds.join(","), amplitudeItemListContext.itemListName, offers]);
};
import {useEffect, useMemo, useRef} from "react";

import {RequestState} from "@pg-mono/request-state";

import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {IOfferListOffer} from "../../types/IOfferListOffer";
import {getOfferListingAmplitudeItemListContext} from "../helpers/get_offer_listing_amplitude_item_list_context";
import {isOfferListingRouteQuerySyncedWithLatestQuery} from "../helpers/is_offer_listing_route_query_synced_with_latest_query";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

type OfferListingRouteQuery = Record<string, string | string[] | null | boolean | undefined>;

interface IUseOfferListingAmplitudeViewItemListTrackingParams {
    offers: IOfferListOffer[];
    listingTitle: string;
    routeQuery: OfferListingRouteQuery;
    latestQuery: IOfferListLatestQuery;
    requestState: RequestState;
    isInitialOfferListFetchDone: boolean;
    isPromotionsTab: boolean;
    showPromotionTabs: boolean;
}

const getAmplitudeViewItemListContextKey = (itemListName: string | string[], offerIds: string[]) => `${JSON.stringify(itemListName)}|${offerIds.join(",")}`;

// DS-A-32
export const useOfferListingAmplitudeViewItemListTracking = (params: IUseOfferListingAmplitudeViewItemListTrackingParams) => {
    const {offers, listingTitle, routeQuery, latestQuery, requestState, isInitialOfferListFetchDone, isPromotionsTab, showPromotionTabs} = params;

    const prevTrackedContextKeyRef = useRef<string | null>(null);

    const amplitudeItemListContext = useMemo(
        () =>
            getOfferListingAmplitudeItemListContext({
                listingTitle,
                isPromotionsTab,
                hasPromotionTabs: showPromotionTabs
            }),
        [listingTitle, isPromotionsTab, showPromotionTabs]
    );

    const offerIds = useMemo(() => offers.map(({id}) => id.toString()), [offers]);
    const isListingQuerySyncedWithRoute = isOfferListingRouteQuerySyncedWithLatestQuery(routeQuery, latestQuery);

    useEffect(() => {
        if (!isInitialOfferListFetchDone) {
            return;
        }

        if (requestState === RequestState.Waiting) {
            prevTrackedContextKeyRef.current = null;
            return;
        }

        if (requestState !== RequestState.Success || !isListingQuerySyncedWithRoute) {
            return;
        }

        const contextKey = getAmplitudeViewItemListContextKey(amplitudeItemListContext.itemListName, offerIds);

        if (prevTrackedContextKeyRef.current === contextKey) {
            return;
        }

        prevTrackedContextKeyRef.current = contextKey;

        trackAmplitudeOfferViewItemList({
            offers,
            itemListName: amplitudeItemListContext.itemListName
        });
    }, [isInitialOfferListFetchDone, requestState, isListingQuerySyncedWithRoute, offerIds.join(","), amplitudeItemListContext.itemListName, offers]);
};
